import React, { PureComponent } from "react"

import Spinner from "../components/Spinner/Spinner"

export function asyncLoad(Component) {
  return Component.maybeAsyncLoad()
    .then(m => m.default)
    .then(AsyncComponent => {
      Component.displayName = `Async(${Component.displayName})` // eslint-disable-line no-param-reassign
      Component.AsyncComponent = AsyncComponent // eslint-disable-line no-param-reassign
    })
}

export default function makeAsync(getComponent, { Loader = Spinner, lazy } = {}) {
  return class Async extends PureComponent {
    static AsyncComponent = null

    static maybeAsyncLoad = lazy ? null : getComponent

    state = { Component: Loader }

    componentDidMount() {
      if (!Async.AsyncComponent) {
        getComponent()
          .then(m => m.default)
          .then(AsyncComponent => {
            Async.displayName = `Async(${AsyncComponent.displayName})` // eslint-disable-line no-param-reassign
            Async.AsyncComponent = AsyncComponent
            this.setState({ Component: AsyncComponent })
          })
      } else {
        this.setState({ Component: Async.AsyncComponent }) // eslint-disable-line
      }
    }

    render() {
      const { Component } = this.state

      return <Component {...this.props} />
    }
  }
}
